var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommentExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M13 3C6.924 3 2 6.948 2 11.821c0 2.104.92 4.03 2.45 5.544-.538 2.137-2.334 4.041-2.355 4.062a.336.336 0 00-.065.37.337.337 0 00.314.203c2.849 0 4.984-1.349 6.041-2.18a13.25 13.25 0 004.615.823c6.076 0 11-3.949 11-8.822C24 6.948 19.076 3 13 3zm0 14.25c-.76 0-1.375-.606-1.375-1.357 0-.75.614-1.357 1.375-1.357.76 0 1.375.606 1.375 1.357 0 .75-.614 1.357-1.375 1.357zm1.091-4.682a.68.68 0 01-.683.61h-.816a.68.68 0 01-.683-.61l-.55-5.429a.684.684 0 01.683-.746h1.916a.68.68 0 01.683.746l-.55 5.429z"
  }))));
}

export default SvgCommentExclamation;